<template>
  <Transition name="fade">
    <div
      v-if="open"
      class="fixed inset-0 z-50 flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
      @keydown.esc="$emit('cancel')"
    >
      <!-- overlay -->
      <div class="absolute inset-0 bg-black/60" @click="$emit('cancel')"></div>

      <!-- modal -->
      <div
        class="relative w-full max-w-md rounded-2xl overflow-hidden bg-gradient-to-br from-[#1c1f26] to-[#181b21] border border-white/10 shadow-[0_0_60px_rgba(0,0,0,0.75)]"
      >
        <!-- glow -->
        <div
          class="absolute -bottom-16 -right-16 w-64 h-48 bg-red-500/20 blur-3xl rounded-full"
        ></div>

        <div class="relative p-6">
          <div class="flex items-start justify-between gap-4 text-start">
            <div>
              <h3 class="text-lg font-semibold text-white">{{ title }}</h3>
              <p class="text-sm text-gray-400 mt-2">{{ description }}</p>
            </div>

            <button
              type="button"
              class="w-9 h-9 rounded-lg bg-white/5 border border-white/10 text-gray-200 hover:bg-white/10 transition flex items-center justify-center"
              @click="$emit('cancel')"
              title="Fechar"
            >
              ✕
            </button>
          </div>

          <div class="mt-5 rounded-xl bg-white/5 border border-white/10 p-4">
            <p class="text-xs text-gray-400">Resumo</p>

            <!-- Binário -->
            <p
              v-if="responseMode === 'binary'"
              class="text-sm text-gray-200 mt-2"
            >
              SIM:
              <span class="text-green-400 font-semibold">{{ yesCount }}</span>
              &nbsp;•&nbsp; NÃO:
              <span class="text-red-400 font-semibold">{{ noCount }}</span>
              &nbsp;•&nbsp; Total:
              <span class="text-white font-semibold">{{ total }}</span>
            </p>

            <!-- Escala -->
            <div v-else class="mt-2 space-y-2">
              <p class="text-sm text-gray-200">
                Respondidas:
                <span class="text-red-300 font-semibold">
                  {{ answeredCount }}
                </span>
                &nbsp;•&nbsp; Total:
                <span class="text-white font-semibold">{{ total }}</span>
              </p>

              <p class="text-xs text-gray-500">
                Escala utilizada:
                <span class="text-gray-300 font-medium">
                  {{ scaleLabel }}
                </span>
              </p>
            </div>
          </div>

          <div class="mt-6 flex items-center gap-3">
            <button
              type="button"
              class="flex-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-gray-200 hover:bg-white/10 transition"
              @click="$emit('cancel')"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="flex-1 px-4 py-3 rounded-xl bg-gradient-to-br from-[#22b558] to-[#22c55e] hover:bg-green-200 hover:scale-[1.02] transition-all hover:shadow-[0_0_10px_#22b558] text-white font-semibold"
              @click="$emit('confirm')"
            >
              Confirmar envio
            </button>
          </div>

          <p class="mt-4 text-xs text-gray-500">
            Ao confirmar, as respostas serão registradas no sistema.
          </p>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed, defineEmits, defineProps } from "vue";

const props = defineProps({
  open: { type: Boolean, default: false },
  title: { type: String, default: "Confirmar envio" },
  description: {
    type: String,
    default: "Deseja enviar o questionário agora?",
  },

  responseMode: {
    type: String,
    default: "binary", // binary | scale_1_5
  },

  yesCount: { type: Number, default: 0 },
  noCount: { type: Number, default: 0 },
  answeredCount: { type: Number, default: 0 },
  total: { type: Number, default: 0 },
});

defineEmits(["confirm", "cancel"]);

const scaleLabel = computed(() => {
  if (props.responseMode === "scale_1_5") {
    return "1 a 5";
  }

  return "Sim / Não";
});
</script>

<style scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.18s ease;
}
</style>
